<!--
 * @Description: 用户协议维护
 * @Author: 钱磊
 * @Date: 2022-08-16 10:23:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-31 15:11:59
-->
<!--  -->
<template>
	<div class="h100">
		<div class="h100" v-if="!routeQuery">
			<w-split class="h100" v-model="splitValue">
				<div class="w-page-main left" slot="left">
					<!-- 左侧专家库列表 -->
					<div class="w-page-container pdb10">
						<el-row type="flex" justify="space-between">
							<el-col :span="10">用户协议</el-col>
							<el-col :span="3">
								<el-button type="success" size="small" @click="addrules('add')">新增</el-button>
							</el-col>
						</el-row>
						<hr />
						<div class="w-table-content mt10">
							<vxe-table
								ref="leftTable"
								:data="tableObj.tableData"
								:loading="tableObj.loading"
								:border="tableObj.border"
								:resizable="tableObj.resizable"
								:size="tableObj.size"
								highlight-current-row
								highlight-hover-row
								show-overflow="tooltip"
								show-header-overflow="tooltip"
								@current-change="onLeftRowClick"
							>
								<vxe-table-column field="sname" title="协议名称" align="center"></vxe-table-column>
								<vxe-table-column title="备注用途" field="remark" align="center"> </vxe-table-column>
								<vxe-table-column title="操作" width="100" align="center">
									<template v-slot="{ row }">
										<el-button type="primary" icon="el-icon-edit" size="mini" circle @click="addrules('eidt', row)"></el-button>
										<el-button type="danger" icon="el-icon-delete" size="mini" circle @click="delRule(row)"></el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
					</div>
				</div>
				<div class="w-table-layout right" slot="right">
					<div class="operation-layout">
						<div class="operation-head">
							<div class="opration-title">
								协议版本<span class="red">{{ searchObj.totalResult }}</span
								>份
							</div>
							<div>
								<el-button type="success" size="small" @click="addVersion('add')">新增版本内容</el-button>
								<el-button type="primary" size="small" @click="getVersionList">刷新</el-button>
							</div>
						</div>
						<hr />
						<div class="operation-container w-table-layout w-table-page" v-if="!routeQuery">
							<div class="w-table-content mt10">
								<vxe-table
									ref="rightTable"
									:data="versionTableObj.tableData"
									:loading="versionTableObj.loading"
									:border="versionTableObj.border"
									:resizable="versionTableObj.resizable"
									height="98%"
									:size="versionTableObj.size"
									highlight-current-row
									show-overflow="tooltip"
									show-header-overflow="tooltip"
								>
									<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
									<vxe-table-column field="version" title="版本" align="center"></vxe-table-column>
									<vxe-table-column title="创建人" field="createUser" align="center"> </vxe-table-column>
									<vxe-table-column title="创建日期" field="createDate" align="center">
										<template v-slot="{ row }">
											{{ row.createDate | timeFilter }}
										</template>
									</vxe-table-column>
									<vxe-table-column title="操作" width="180" align="center">
										<template v-slot="{ row }">
											<el-button type="primary" size="mini" @click="addVersion('eidt', row)">编辑</el-button>
											<el-button type="danger" size="mini" @click="delVersion(row)">删除</el-button>
										</template>
									</vxe-table-column>
								</vxe-table>
							</div>
						</div>
						<div class="w-table-footer">
							<vxe-pager
								size="mini"
								:current-page="searchObj.currentPage"
								:page-size="searchObj.pageSize"
								:total="searchObj.totalResult"
								class="text-center"
								:page-sizes="[10, 20, 50, 100]"
								:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
								@page-change="handlePageChange"
							>
							</vxe-pager>
						</div>
					</div>
				</div>
			</w-split>
		</div>
		<div v-else>
			<add-version @close="getDealList"></add-version>
		</div>
		<!-- 弹窗 -->
		<el-dialog
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:title="dialogObj.title"
			:fullscreen="dialogObj.fullscreen"
			center
			class="add-dialog"
			:close-on-click-modal="false"
		>
			<!-- 添加协议 -->
			<template>
				<el-form ref="addAgree" :model="addAgreeForm" size="medium" :rules="addRule" label-width="110px">
					<el-row class="mt20">
						<el-col :span="20" :offset="2">
							<el-form-item label="协议名称：" prop="sname">
								<el-input size="small" v-model="addAgreeForm.sname" placeholder="请输入" maxlength="30" clearable></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="mt20">
						<el-col :span="20" :offset="2">
							<el-form-item label="备注用途：" prop="remark">
								<el-input
									size="small"
									v-model="addAgreeForm.remark"
									placeholder="请简单描述下该协议用途"
									maxlength="20"
									clearable
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</template>
			<!-- footer 组件 -->
			<div slot="footer" class="pdb10 text-center">
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
				<el-button type="primary" size="small" class="btn btn-blue" @click="submitForm" :loading="dialogObj.btnLoading">确 定 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as API from 'api/modules/rulesManagement'
import { mapState } from 'vuex'
import AddVersion from './add-version.vue'
export default {
	data() {
		return {
			splitValue: 0.35, //左右表格分配
			leftRowId: '',
			// 表格对象
			tableObj: {
				//左侧表格对象
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small'
			},
			addAgreeForm: {
				sname: '',
				remark: ''
			},
			addRule: {
				//添加专家库非空验证
				sname: [{ required: true, message: '协议名称不能为空！', trigger: 'blur' }],
				remark: [{ required: true, message: '协议用途不能为空！', trigger: 'blur' }]
			},
			// 弹窗对象
			dialogObj: {
				visible: false,
				width: '600px',
				title: '新增协议',
				fullscreen: false,
				btnLoading: false
			},
			searchObj: {
				currentPage: 1, // 当前页码
				pageSize: 10, // 当前每页条数
				totalResult: 0
			},
			// 协议版本表格对象
			versionTableObj: {
				//左侧表格对象
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small'
			}
		}
	},
	components: {
		AddVersion
	},
	filters: {
		timeFilter(val) {
			if (val) {
				return val.slice(0, 10)
			}
		}
	},
	mounted() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchObj')) {
				this.searchObj = JSON.parse(this.$getSessionItem('searchObj'))
				// 移除 避免污染
				this.$removeSessionItem('searchObj')
			}
			if (this.$getSessionItem('versionDetail')) {
				// 移除 避免污染
				this.$removeSessionItem('versionDetail')
			}
			if (this.$getSessionItem('leftRowId')) {
				this.leftRowId = JSON.parse(this.$getSessionItem('leftRowId'))
				// 移除 避免污染
				this.$removeSessionItem('leftRowId')
			}
		}
		this.getDealList()
	},
	methods: {
		/***** 左侧协议信息 *****/
		// 获取协议列表
		getDealList() {
			API.getDealList({}).then((res) => {
				if (res.operationCode == '1') {
					this.tableObj.tableData = res.data
					if (res.data.length > 0) {
						if (this.leftRowId !== '') {
							let _item = res.data.find((x) => x.id === this.leftRowId)
							this.$refs.leftTable.setCurrentRow(_item)
							this.onLeftRowClick({ row: _item })
						} else {
							this.$refs.leftTable ? this.$refs.leftTable.setCurrentRow(res.data[0]) : ''
							this.onLeftRowClick({ row: res.data[0] })
						}
					}
				}
			})
		},
		// 添加协议按钮
		addrules(type, row) {
			if (type == 'add') {
				this.dialogObj.title = '新增协议'
				this.addAgreeForm.id = ''
				this.addAgreeForm.sname = ''
				this.addAgreeForm.remark = ''
				this.dialogObj.visible = true
			} else {
				this.dialogObj.title = '修改协议'
				this.addAgreeForm.id = row.id
				this.addAgreeForm.sname = row.sname
				this.addAgreeForm.remark = row.remark
				this.dialogObj.visible = true
			}
		},
		//左侧行点击
		onLeftRowClick({ row, rowIndex, $rowIndex }) {
			this.leftRowId = row.id
			this.$setSessionItem('leftRowId', JSON.stringify(this.leftRowId))
			this.getVersionList(1)
		},
		//弹出框新增或修改用户协议提交按钮
		submitForm() {
			this.dialogObj.btnLoading = true
			this.$refs.addAgree.validate((valid) => {
				if (valid) {
					let params = Object.assign({}, this.addAgreeForm)
					API.saveDeal(params)
						.then((res) => {
							if (res.operationCode == '1') {
								this.dialogObj.btnLoading = false
								this.$message.success(res.data)
								this.dialogObj.visible = false
								this.getDealList()
							} else {
								this.dialogObj.btnLoading = false
								this.$message.error(res.msg)
							}
						})
						.catch((err) => {
							this.dialogObj.btnLoading = false
							this.$message.error(res.msg)
						})
				} else {
					this.dialogObj.btnLoading = false
				}
			})
		},
		// 删除协议
		delRule(row) {
			this.$confirm('请确认是否需要删除该协议?', '删除', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning'
			})
				.then(() => {
					API.delDeal({ id: row.id }).then((res) => {
						if (res.operationCode == '1') {
							this.$message({
								type: 'success',
								message: '删除成功!'
							})
							this.getDealList()
						} else {
							this.$message({
								type: 'warning',
								message: res.msg
							})
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		/***** 左侧协议版本信息 *****/
		//  获取协议版本列表
		getVersionList(page) {
			if (page) {
				this.searchObj.pageSize = 10
				this.searchObj.currentPage = 1
			}
			let params = {
				size: this.searchObj.pageSize, // 当前每页条数
				current: this.searchObj.currentPage, // 当前页码
				dealId: this.leftRowId //协议id
			}
			this.versionTableObj.loading = true
			API.getVersionPageList(params).then((res) => {
				this.versionTableObj.loading = false
				if (res.operationCode === 1) {
					this.versionTableObj.tableData = res.data.records
					this.searchObj.totalResult = parseInt(res.data.total)
				}
			})
		},
		addVersion(type, row) {
			if (type == 'add') {
				this.$router.push({
					path: '/agreement-rule',
					query: {
						type: 'add'
					}
				})
				// 存值
				this.$setSessionItem('leftRowId', JSON.stringify(this.leftRowId))
			} else {
				let rowObj = Object.assign({}, row)
				// 存值
				this.$setSessionItem('versionDetail', JSON.stringify(rowObj))
				// 存值
				this.$setSessionItem('searchObj', JSON.stringify(this.searchObj))
				// 存值
				this.$setSessionItem('leftRowId', JSON.stringify(this.leftRowId))
				this.$router.push({
					path: '/agreement-rule',
					query: {
						type: 'edit'
					}
				})
			}
		},
		// 删除协议
		delVersion(row) {
			this.$confirm('请确认是否需要删除该协议?', '删除', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning'
			})
				.then(() => {
					API.delVersion({ id: row.id }).then((res) => {
						if (res.operationCode == '1') {
							this.$message({
								type: 'success',
								message: '删除成功!'
							})
							this.getVersionList()
						} else {
							this.$message({
								type: 'warning',
								message: res.msg
							})
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObj.currentPage = currentPage
			this.searchObj.pageSize = pageSize
			this.getVersionList()
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', { isBack: (state) => state.isBack })
	}
}
</script>
<style scoped lang="less">
.w-page-main {
	padding-top: 20px;
	overflow-y: auto;
}
.w-table-layout {
	padding: 20px;
}
hr {
	margin-top: 10px;
	height: 5px;
	border: none;
	border-top: 2px dotted #797979;
}
.red {
	color: red;
	display: inline-block;
	padding: 0 5px;
}
.operation-head {
	display: flex;
	justify-content: space-between;
	.opration-title {
		line-height: 32px;
	}
}
</style>
